import { render, staticRenderFns } from "./IncomeDialog.vue?vue&type=template&id=4637c4f1&scoped=true"
import script from "./IncomeDialog.vue?vue&type=script&lang=js"
export * from "./IncomeDialog.vue?vue&type=script&lang=js"
import style0 from "./IncomeDialog.vue?vue&type=style&index=0&id=4637c4f1&prod&scoped=true&lang=scss"
import style1 from "./IncomeDialog.vue?vue&type=style&index=1&id=4637c4f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4637c4f1",
  null
  
)

export default component.exports